exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#bee-plugin[data-v-e0ed5d7a] {\n    height:100vh;\n}\n", ""]);

// exports
